import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  inject,
  OnChanges,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { GroupRepository } from "../../../user/group/group.repository";
import { SelectItem } from "primeng/api";
import { Group } from "../../../user/group/group.model";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { SelectedChipsComponent } from "../../chip/selected-chips.component";
import { Checkbox } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";

export interface GroupChangeEvent {
  originalEvent: MouseEvent;
  value: Group[];
}

@Component({
  selector: "app-user-group-select",
  templateUrl: "./user-group-select.component.html",
  styleUrls: ["./user-group-select.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, Checkbox, FormsModule, SelectedChipsComponent],
})
export class UserGroupSelectComponent implements OnInit, OnChanges {
  private groupRepository = inject(GroupRepository);

  @Input() public selectedUserGroups: Group[] = [];
  public readonly groupIds = input<number[]>(undefined);
  public readonly userGroupsChange = output<Group[]>();

  public groupList: SelectItem[] = [];
  public subscription = new Subscription();

  ngOnInit() {
    this.buildGroupList();
  }

  ngOnChanges(changes: SimpleChanges) {
    const groupIds = this.groupIds();
    if (groupIds && groupIds.length) {
      this.updateSelectedGroups();
    } else if (changes.groupIds && !changes.groupIds.isFirstChange()) {
      // Clearing the filter passes an empty list, which `updateSelectedGroups`
      // ignores (it only maps ids onto groups) — drop the chips here.
      this.selectedUserGroups = [];
    }
  }

  private updateSelectedGroups(): void {
    const groupIds = this.groupIds();
    if (groupIds && groupIds.length && this.groupList.length) {
      const groups = [];
      for (const id of groupIds) {
        const exists = this.groupList.find((item) => item.value.getId() == id);
        if (exists) {
          groups.push(exists.value);
        }
      }
      this.selectedUserGroups = groups;
    }
  }

  public onGroupChange(event: Group[]) {
    this.userGroupsChange.emit(event);
  }

  public readonly chipLabel = (group: Group): string => group.getName();
  public readonly chipKey = (group: Group): number => group.getId();

  public removeGroup(group: Group) {
    this.selectedUserGroups = (this.selectedUserGroups ?? []).filter(
      (item) => item.getId() !== group.getId(),
    );
    this.onGroupChange(this.selectedUserGroups);
  }

  public isSelected(group: Group): boolean {
    return (this.selectedUserGroups ?? []).some(
      (item) => item.getId() === group.getId(),
    );
  }

  private buildGroupList() {
    this.groupRepository.list().subscribe((groupList) => {
      groupList.forEach((group) => {
        this.groupList.push({ label: group.getName(), value: group });
      });
      this.updateSelectedGroups();
    });
  }
}
